import { ReactNode } from 'react';
import {
  FaMobileAlt,
  FaLaptop,
  FaBolt,
  FaDatabase,
  FaWindows,
  FaCheckCircle,
  FaClock,
  FaShieldAlt,
  FaUsers,
  FaBuilding,
  FaMapMarkerAlt,
  FaHandshake,
  FaComments,
  FaTools,
  FaClipboardCheck,
  FaTruck,
} from 'react-icons/fa';

export type AboutCardItem = {
  icon: ReactNode;
  title: string;
  description: string;
  color: string;
  bg: string;
};

export const aboutServices: AboutCardItem[] = [
  {
    icon: <FaMobileAlt data-component-id="src/components/about/aboutData.tsx:31:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="31" data-component-end-line="31" data-component-file="aboutData.tsx" data-component-name="FaMobileAlt" data-component-content="%7B%22elementName%22%3A%22FaMobileAlt%22%7D" size={32} />,
    title: 'Mobile Repairs',
    description: 'Screen, battery, charging port, and software issues.',
    color: '#1E90FF',
    bg: 'rgba(30, 144, 255, 0.1)',
  },
  {
    icon: <FaLaptop data-component-id="src/components/about/aboutData.tsx:38:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="38" data-component-end-line="38" data-component-file="aboutData.tsx" data-component-name="FaLaptop" data-component-content="%7B%22elementName%22%3A%22FaLaptop%22%7D" size={32} />,
    title: 'Laptop Repairs',
    description: 'Screen, battery, storage, data transfer, and Windows installation.',
    color: '#FF6F00',
    bg: 'rgba(255, 111, 0, 0.1)',
  },
  {
    icon: <FaBolt data-component-id="src/components/about/aboutData.tsx:45:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="45" data-component-end-line="45" data-component-file="aboutData.tsx" data-component-name="FaBolt" data-component-content="%7B%22elementName%22%3A%22FaBolt%22%7D" size={32} />,
    title: 'Fast Service',
    description: 'Most repairs done same-day with transparent timelines.',
    color: '#22C55E',
    bg: 'rgba(34, 197, 94, 0.1)',
  },
  {
    icon: <FaDatabase data-component-id="src/components/about/aboutData.tsx:52:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="52" data-component-end-line="52" data-component-file="aboutData.tsx" data-component-name="FaDatabase" data-component-content="%7B%22elementName%22%3A%22FaDatabase%22%7D" size={32} />,
    title: 'Data Safety',
    description: 'We ensure data safety and guide customers to backup before repair.',
    color: '#8B5CF6',
    bg: 'rgba(139, 92, 246, 0.1)',
  },
  {
    icon: <FaWindows data-component-id="src/components/about/aboutData.tsx:59:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="59" data-component-end-line="59" data-component-file="aboutData.tsx" data-component-name="FaWindows" data-component-content="%7B%22elementName%22%3A%22FaWindows%22%7D" size={32} />,
    title: 'Software Solutions',
    description: 'OS updates, malware removal, and software troubleshooting.',
    color: '#EC4899',
    bg: 'rgba(236, 72, 153, 0.1)',
  },
  {
    icon: <FaCheckCircle data-component-id="src/components/about/aboutData.tsx:66:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="66" data-component-end-line="66" data-component-file="aboutData.tsx" data-component-name="FaCheckCircle" data-component-content="%7B%22elementName%22%3A%22FaCheckCircle%22%7D" size={32} />,
    title: 'Trusted Repairs',
    description: 'Genuine parts, transparent pricing, and warranty on all repairs.',
    color: '#22C55E',
    bg: 'rgba(34, 197, 94, 0.1)',
  },
];

export const aboutFeatures: AboutCardItem[] = [
  {
    icon: <FaCheckCircle data-component-id="src/components/about/aboutData.tsx:76:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="76" data-component-end-line="76" data-component-file="aboutData.tsx" data-component-name="FaCheckCircle" data-component-content="%7B%22elementName%22%3A%22FaCheckCircle%22%7D" size={40} />,
    title: 'Trusted Repairs',
    description: 'All repairs are done using genuine parts with full transparency.',
    color: '#22C55E',
    bg: 'rgba(34, 197, 94, 0.1)',
  },
  {
    icon: <FaClock data-component-id="src/components/about/aboutData.tsx:83:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="83" data-component-end-line="83" data-component-file="aboutData.tsx" data-component-name="FaClock" data-component-content="%7B%22elementName%22%3A%22FaClock%22%7D" size={40} />,
    title: 'Quick Turnaround',
    description: 'Most repairs completed same-day or within a few hours.',
    color: '#1E90FF',
    bg: 'rgba(30, 144, 255, 0.1)',
  },
  {
    icon: <FaShieldAlt data-component-id="src/components/about/aboutData.tsx:90:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="90" data-component-end-line="90" data-component-file="aboutData.tsx" data-component-name="FaShieldAlt" data-component-content="%7B%22elementName%22%3A%22FaShieldAlt%22%7D" size={40} />,
    title: 'Warranty Guaranteed',
    description: 'Every repair comes with 60-day parts and labor warranty.',
    color: '#FF6F00',
    bg: 'rgba(255, 111, 0, 0.1)',
  },
];

export const aboutWhoWeHelp: AboutCardItem[] = [
  {
    icon: <FaUsers data-component-id="src/components/about/aboutData.tsx:100:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="100" data-component-end-line="100" data-component-file="aboutData.tsx" data-component-name="FaUsers" data-component-content="%7B%22elementName%22%3A%22FaUsers%22%7D" size={32} />,
    title: 'Personal Customers',
    description: 'Reliable repair support for everyday phone, tablet, and laptop problems.',
    color: '#1E90FF',
    bg: 'rgba(30, 144, 255, 0.1)',
  },
  {
    icon: <FaBuilding data-component-id="src/components/about/aboutData.tsx:107:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="107" data-component-end-line="107" data-component-file="aboutData.tsx" data-component-name="FaBuilding" data-component-content="%7B%22elementName%22%3A%22FaBuilding%22%7D" size={32} />,
    title: 'Small Businesses',
    description: 'Repair help for teams that need working devices and less downtime.',
    color: '#FF6F00',
    bg: 'rgba(255, 111, 0, 0.1)',
  },
  {
    icon: <FaHandshake data-component-id="src/components/about/aboutData.tsx:114:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="114" data-component-end-line="114" data-component-file="aboutData.tsx" data-component-name="FaHandshake" data-component-content="%7B%22elementName%22%3A%22FaHandshake%22%7D" size={32} />,
    title: 'Local Offices',
    description: 'Trusted support for offices, sales teams, and service-based businesses.',
    color: '#22C55E',
    bg: 'rgba(34, 197, 94, 0.1)',
  },
];

export const aboutValues: AboutCardItem[] = [
  {
    icon: <FaComments data-component-id="src/components/about/aboutData.tsx:124:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="124" data-component-end-line="124" data-component-file="aboutData.tsx" data-component-name="FaComments" data-component-content="%7B%22elementName%22%3A%22FaComments%22%7D" size={32} />,
    title: 'Clear Communication',
    description: 'We keep customers informed with straightforward updates and honest repair advice.',
    color: '#1E90FF',
    bg: 'rgba(30, 144, 255, 0.1)',
  },
  {
    icon: <FaClipboardCheck data-component-id="src/components/about/aboutData.tsx:131:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="131" data-component-end-line="131" data-component-file="aboutData.tsx" data-component-name="FaClipboardCheck" data-component-content="%7B%22elementName%22%3A%22FaClipboardCheck%22%7D" size={32} />,
    title: 'Honest Pricing',
    description: 'Clear quotes and transparent repair recommendations before work begins.',
    color: '#FF6F00',
    bg: 'rgba(255, 111, 0, 0.1)',
  },
  {
    icon: <FaTools data-component-id="src/components/about/aboutData.tsx:138:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="138" data-component-end-line="138" data-component-file="aboutData.tsx" data-component-name="FaTools" data-component-content="%7B%22elementName%22%3A%22FaTools%22%7D" size={32} />,
    title: 'Quality Repairs',
    description: 'Careful workmanship, reliable parts, and testing that supports lasting results.',
    color: '#22C55E',
    bg: 'rgba(34, 197, 94, 0.1)',
  },
];

export const aboutProcess = [
  {
    step: '01',
    title: 'Check the Issue',
    description: 'We inspect the device and understand the problem before recommending a repair.',
  },
  {
    step: '02',
    title: 'Share a Clear Quote',
    description: 'You get a straightforward repair quote and timeline before work starts.',
  },
  {
    step: '03',
    title: 'Complete the Repair',
    description: 'We repair the device carefully using quality parts and proven repair steps.',
  },
  {
    step: '04',
    title: 'Test and Return',
    description: 'Your device is tested and returned with clear follow-up support if needed.',
  },
];

export const aboutServiceArea = [
  {
    icon: <FaMapMarkerAlt data-component-id="src/components/about/aboutData.tsx:171:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="171" data-component-end-line="171" data-component-file="aboutData.tsx" data-component-name="FaMapMarkerAlt" data-component-content="%7B%22elementName%22%3A%22FaMapMarkerAlt%22%7D" size={28} />,
    title: 'Kitchener',
    description: 'Local device repair support for customers and businesses across Kitchener.',
    color: '#1E90FF',
    bg: 'rgba(30, 144, 255, 0.1)',
  },
  {
    icon: <FaMapMarkerAlt data-component-id="src/components/about/aboutData.tsx:178:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="178" data-component-end-line="178" data-component-file="aboutData.tsx" data-component-name="FaMapMarkerAlt" data-component-content="%7B%22elementName%22%3A%22FaMapMarkerAlt%22%7D" size={28} />,
    title: 'Waterloo',
    description: 'Convenient repair service for phones, tablets, and laptops in Waterloo.',
    color: '#FF6F00',
    bg: 'rgba(255, 111, 0, 0.1)',
  },
  {
    icon: <FaMapMarkerAlt data-component-id="src/components/about/aboutData.tsx:185:10" data-component-path="src/components/about/aboutData.tsx" data-component-line="185" data-component-end-line="185" data-component-file="aboutData.tsx" data-component-name="FaMapMarkerAlt" data-component-content="%7B%22elementName%22%3A%22FaMapMarkerAlt%22%7D" size={28} />,
    title: 'Cambridge',
    description: 'Fast and dependable repair help for local homes, offices, and teams in Cambridge.',
    color: '#22C55E',
    bg: 'rgba(34, 197, 94, 0.1)',
  },
];

export const aboutServiceAreaHighlights = [
  'Support for personal and business devices',
  'Phones, tablets, iPads, and laptops',
  'Local help with clear communication and trusted service',
  'Pickup and drop options available when needed',
];
